var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 30,
    viewBox: "0 0 69 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.523462 1.28349C0.191889 1.6219 0 2.14879 0 2.83112V27.1696C0 27.8519 0.191889 28.3788 0.523462 28.7172L0.605298 28.7915L14.5935 15.1586V14.8366L0.605298 1.2037L0.523462 1.28349Z",
    fill: "#11302D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9427 19.7051L16.2852 15.1585V14.8366L20.9484 10.29L21.0528 10.3491L26.5752 13.4127C28.1513 14.2822 28.1513 15.7129 26.5752 16.5878L21.0528 19.6459L20.9427 19.7051Z",
    fill: "#11302D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2068 20.4926L15.4392 15.8442L1.36914 29.5638C1.8926 30.1003 2.74623 30.165 3.71697 29.6285L20.2068 20.4926Z",
    fill: "#11302D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2068 9.50247L3.71697 0.36661C2.74623 -0.164401 1.8926 -0.0997465 1.36914 0.436767L15.4392 14.1509L20.2068 9.50247Z",
    fill: "#11302D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7578 1.95996V28.0404",
    stroke: "#11302D",
    strokeWidth: 0.301508
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6657 15.9542C64.6308 12.1643 67.8485 10.3205 67.9956 10.2347C66.1733 7.6442 63.3488 7.29026 62.3562 7.26204C59.9839 7.01863 57.6828 8.64605 56.4744 8.64605C55.2418 8.64605 53.3809 7.28556 51.3752 7.32554C48.7943 7.36434 46.3798 8.82126 45.0556 11.0837C42.3227 15.6966 44.3609 22.4756 46.9792 26.2043C48.289 28.0305 49.8195 30.0694 51.8227 29.9977C53.7825 29.9189 54.5146 28.7795 56.8796 28.7795C59.2229 28.7795 59.9103 29.9977 61.9534 29.9518C64.0567 29.9189 65.3809 28.1175 66.6448 26.2749C68.1584 24.1818 68.7663 22.1205 68.7904 22.0146C68.7409 21.9982 64.7055 20.4966 64.6657 15.9542Z",
    fill: "#11302D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8064 4.80915C61.8605 3.52392 62.5817 1.77538 62.3815 0.000976562C60.8559 0.0668259 58.9479 1.02987 57.8492 2.28689C56.8772 3.39457 56.0088 5.21013 56.2331 6.91751C57.9469 7.04215 59.7065 6.0744 60.8064 4.80915Z",
    fill: "#11302D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/appIcon.2ac1becd6b8274f5fc616982d003423a.svg";
export { ForwardRef as ReactComponent };